module.exports = {
      id: "close-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "svg-sprite-4990048fd6d3fd501089a0638bd441f8.svg#close",
      toString: function () {
        return this.url;
      }
    }